import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Header from '../../common/Header';
import PageContentPanel from '../panels/PageContentPanel';
import { DashboardTimelineType, OwnerType } from '../../../constants/ComponentTypes';
import { hasKLFollowCallBeenEnabled } from '../../../utils/userUtils';

const styles = () => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    overflowY: 'auto',
  },
});

class ByFollowCallStatus extends React.Component {
  initialState = {
    ownerType: OwnerType.OWN.value,
  }
  constructor(props) {
    super(props);
    const ownType = props.location.state && props.location.state.ownerType ? props.location.state.ownerType : OwnerType.OWN.value;
    this.state = { ...this.initialState, ...{ ownerType: ownType } };
  }

  componentDidMount() {
    this.props.getUserInfo();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Header
          title="ダッシュボード"
          secondaryTitle={DashboardTimelineType.BY_FOLLOW_CALL_STATUS.text}
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() => this.props.goTo('/order-dashboard', {
            ownerType: this.state.ownerType
          })}
        />
        <PageContentPanel
          type={DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value}
          items={this.props.lists}
          goTo={this.props.goTo}
          isLoading={this.props.isLoading}
          pageInfo={this.props.pageInfo}
          getStatus={this.props.getCurrentPersonAllStatus}
          ownerType={this.state.ownerType}
          hasKLFollowCallBeenEnabled={hasKLFollowCallBeenEnabled(this.props.user)}
        />
      </div>
    )
  }
}

ByFollowCallStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  items: PropTypes.object,
  pageInfo: PropTypes.object,
  getCurrentPersonAllStatus: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  user: PropTypes.object,
  location: PropTypes.object,
  lists: PropTypes.object,
};

export default withStyles(styles)(ByFollowCallStatus);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/pages/ByFollowCallStatus.jsx